import { Agent } from "@/types/agent";
import { Button } from "@/components/ui/button";
import { MessageCircle, MessageSquare, ChevronLeft, ChevronRight, Menu } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Bot } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";

interface ChatTopBarProps {
  selectedAgent: Agent | null;
  agents: Agent[];
  onSelectAgent: (agent: Agent) => void;
  onToggleConversations?: () => void;
  isMobile?: boolean;
}

export const ChatTopBar = ({ 
  selectedAgent, 
  agents, 
  onSelectAgent,
  onToggleConversations,
  isMobile 
}: ChatTopBarProps) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
      <div className="flex items-center gap-4">
        {isMobile && onToggleConversations && (
          <Button variant="ghost" size="icon" onClick={onToggleConversations}>
            <Menu className="h-4 w-4" />
          </Button>
        )}
        <div className="hidden md:flex items-center gap-2">
          <Button variant="ghost" size="icon">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="icon">
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <ScrollArea className="flex-1 px-4 max-w-[calc(100%-8rem)]">
        <div className="flex items-center gap-2">
          {agents.map((agent) => (
            <Button
              key={agent.id}
              variant={selectedAgent?.id === agent.id ? "default" : "outline"}
              onClick={() => onSelectAgent(agent)}
              className="gap-2 whitespace-nowrap flex-shrink-0"
            >
              <Avatar className="w-6 h-6">
                <AvatarImage 
                  src={agent.avatar} 
                  alt={agent.name}
                  className="object-cover"
                />
                <AvatarFallback className="bg-primary/10">
                  <Bot className="h-3 w-3" />
                </AvatarFallback>
              </Avatar>
              <span className="hidden md:inline">{agent.name}</span>
            </Button>
          ))}
        </div>
      </ScrollArea>
      <div className="hidden md:flex items-center gap-2">
        <MessageCircle className="h-5 w-5 text-blue-500" />
        <MessageSquare className="h-5 w-5 text-green-500" />
      </div>
    </div>
  );
};